module.exports = __webpack_public_path__ + "static/media/nav_odekake47d4558a8fba4e913df0db0dd4fbe9b2.webp";